import { render, staticRenderFns } from "./Aframe.vue?vue&type=template&id=2fe552e4&"
import script from "./Aframe.vue?vue&type=script&lang=js&"
export * from "./Aframe.vue?vue&type=script&lang=js&"
import style0 from "./Aframe.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports